import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trending-6, trends, downward"} maskId="square-filled-radius-0-stroke-1-IconTrending6"><path fillRule="evenodd" clipRule="evenodd" d="M16.0001 18H22.0001V12H21.0001V16.2715L12.9996 8.29334L9.00008 12.2928L2.50008 5.79285L1.79297 6.49995L9.00008 13.7071L13.0006 9.70657L20.3143 17H16.0001V18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrending6;
